import { HeaderContainer } from '@containers/HeaderContainer';

export function Header() {
  return <HeaderContainer />;
}
